"use strict";

function initializeNeoPartnersNavigation() {
  const header = document.querySelector(".site-header");
  const toggle = document.querySelector("[data-neo-menu-toggle]");
  const menu = document.querySelector("#mobile-navigation");

  if (!header || !toggle || !menu) return;

  const setMenuOpen = (isOpen) => {
    menu.classList.toggle("mobile-menu--open", isOpen);
    toggle.classList.toggle("is-open", isOpen);
    toggle.setAttribute("aria-expanded", String(isOpen));
    toggle.setAttribute("aria-label", isOpen ? "Fechar menu" : "Abrir menu");
    header.classList.toggle("site-header--solid", isOpen || window.scrollY > 30);
  };

  const updateHeader = () => {
    header.classList.toggle(
      "site-header--solid",
      menu.classList.contains("mobile-menu--open") || window.scrollY > 30,
    );
  };

  toggle.addEventListener("click", () => {
    setMenuOpen(!menu.classList.contains("mobile-menu--open"));
  });

  menu.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => setMenuOpen(false));
  });

  document
    .querySelectorAll('.cta[href="#formulario"], .header-cta[href="#formulario"]')
    .forEach((link) => {
      link.addEventListener("click", (event) => {
        if (!window.matchMedia("(max-width: 720px)").matches) return;

        const leadForm = document.querySelector("#lead-form");
        if (!leadForm) return;

        event.preventDefault();
        setMenuOpen(false);
        leadForm.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") setMenuOpen(false);
  });

  window.addEventListener("scroll", updateHeader, { passive: true });
  updateHeader();
}

function collectNeoPartnersUtmParameters() {
  const query = new URLSearchParams(window.location.search);
  return {
    utm_source: query.get("utm_source") ?? "",
    utm_medium: query.get("utm_medium") ?? "",
    utm_campaign: query.get("utm_campaign") ?? "",
    utm_content: query.get("utm_content") ?? "",
    utm_term: query.get("utm_term") ?? "",
    gclid: query.get("gclid") ?? "",
    fbclid: query.get("fbclid") ?? "",
  };
}

function createNeoPartnersLeadId() {
  if (typeof crypto.randomUUID === "function") return crypto.randomUUID();
  return `neo-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

function initializeNeoPartnersForms() {
  const form = document.querySelector("[data-neo-form]");
  const success = document.querySelector("[data-neo-form-success]");
  const error = document.querySelector("[data-neo-form-error]");
  const reset = document.querySelector("[data-neo-form-reset]");
  const config = document.querySelector("#neo-partners-config");

  if (!(form instanceof HTMLFormElement) || !success || !error) return;

  let submitting = false;

  form.addEventListener("submit", async (event) => {
    event.preventDefault();
    if (submitting || !form.reportValidity()) return;

    const submitButton = form.querySelector('button[type="submit"]');
    const submitLabel = submitButton?.querySelector("span");
    const originalLabel = submitLabel?.textContent ?? "";
    const endpoint = config?.dataset.appscriptUrl?.trim() ?? "";

    if (!endpoint) {
      error.classList.remove("is-hidden");
      return;
    }

    submitting = true;
    error.classList.add("is-hidden");
    if (submitButton) submitButton.disabled = true;
    if (submitLabel) submitLabel.textContent = "ENVIANDO...";

    const formData = new FormData(form);
    const payload = new URLSearchParams({
      data: new Date().toISOString(),
      id: createNeoPartnersLeadId(),
      nome_completo: String(formData.get("nome") ?? ""),
      email: String(formData.get("email") ?? ""),
      whatsapp: String(formData.get("whatsapp") ?? ""),
      nome_empresa: String(formData.get("empresa") ?? ""),
      site_instagram: String(formData.get("site") ?? ""),
      momento_empresa: String(formData.get("momento") ?? ""),
      investe_marketing: String(formData.get("investimento") ?? ""),
      faturamento_mensal: String(formData.get("faturamento") ?? ""),
      ...collectNeoPartnersUtmParameters(),
      pagina_origem: window.location.href,
    });

    try {
      await fetch(endpoint, {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" },
        body: payload.toString(),
      });
      form.reset();
      success.classList.remove("is-hidden");
      document.body.classList.add("has-form-modal");
      reset?.focus();
    } catch {
      error.classList.remove("is-hidden");
    } finally {
      submitting = false;
      if (submitButton) submitButton.disabled = false;
      if (submitLabel) submitLabel.textContent = originalLabel;
    }
  });

  reset?.addEventListener("click", () => {
    success.classList.add("is-hidden");
    document.body.classList.remove("has-form-modal");
    error.classList.add("is-hidden");
    form.querySelector("input, select, button")?.focus();
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && !success.classList.contains("is-hidden")) reset?.click();
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initializeNeoPartnersNavigation();
  initializeNeoPartnersForms();
});
